import {module} from "angular"

export const remoteRoutingModule = module("remoteRoutingModule", [])